import { EditorValue } from 'components/TextEditor/types'
import { Form, UpdateFormValue } from '../hooks/useForm'
import { useConfig } from 'contexts/ConfigContext'
import TextEditor from 'components/TextEditor'
import Select from 'react-select'
import React from 'react'

interface MaterialsProps {
  inStep: boolean
  form: Form
  isSending: boolean
  handleSubmit: () => void
  updateFormValue: UpdateFormValue
}

const Materials: React.FC<MaterialsProps> = ({ inStep, form, isSending, updateFormValue, handleSubmit }) => {
  const config = useConfig()

  const handleMediaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      updateFormValue('media', [...form.media, ...Array.from(event.target.files)])
    }
  }

  const handleRemoveMedia = (index: number) => {
    updateFormValue('media', form.media.filter((_, i) => i !== index))
  }

  return (
    <>
      <div className={`addProfile__content ${inStep ? 'nopadding' : ''}`}>
        <div className='infoLabel'>
          Uzupełnij wspomnienia, możesz to zrobić później
        </div>
        {form.selectedOption !== undefined && config && <div className="myInput">
          <label>Wybierz sentencje</label>
          <Select
            classNamePrefix='mySelect'
            value={form.selectedOption}
            placeholder="Kliknij, aby wybrać"
            options={config?.sentences}
            onChange={(newOption) => {
              updateFormValue('selectedOption', newOption)
            }}
          />
        </div>}

        {form.sentence !== undefined && form.selectedOption?.value === 'other' &&
          <div className="myInput">
            <label>Własna sentencja</label>
            <input
              type="text"
              placeholder='Wpisz sentencje'
              value={form.sentence}
              onChange={(e) => {
                updateFormValue('sentence', e.target.value)
              }}
            />
          </div>
        }
        <div className="myInput">
          <label>Biografia</label>
          <TextEditor
            value={form.biography}
            setValue={(biography: EditorValue) => {
              updateFormValue('biography', biography)
            }}
          />
        </div>
        <div className="myInput desc">
          <label>Pozostałe zdjęcia i filmy</label>
          <div className='drop small' onClick={() => document.getElementById('mediaInput')?.click()}>
            <i className='icon icon--add-photo s32'></i>
            <span>Kliknij, aby dodać zdjęcia lub filmy</span>
          </div>
          <input
            type="file"
            id="mediaInput"
            style={{ display: 'none' }}
            onChange={handleMediaChange}
            accept="image/*,video/*"
            multiple
          />
        </div>
        {form.media.length > 0 && (<>
          <div className='preview'>
            {form.media.map((file, index) => {
              const fileURL = URL.createObjectURL(file)
              return file.type.startsWith('image/') ? (<div>
                <div className="iconWrap" onClick={() => handleRemoveMedia(index)}><i className="icon icon--close"></i></div>
                <img
                  key={index}
                  src={fileURL}
                  alt={`Preview ${index}`}
                  style={{ width: '60px', height: '60px', objectFit: 'cover', marginRight: '5px' }}
                />
              </div>
              ) : (
                <div>
                  <div className="iconWrap" onClick={() => handleRemoveMedia(index)}><i className="icon icon--close"></i></div>
                  <video
                    key={index}
                    src={fileURL}
                    autoPlay
                    muted
                    style={{ width: '60px', height: '60px', objectFit: 'cover', marginRight: '5px' }}
                  />
                </div>
              )
            })}
          </div>
        </>
        )}
      </div>
      {!inStep && <div className="addProfile__footer">
        <button
          className={`btn btn--primary ${isSending ? 'disabled' : ''}`}
          onClick={() => handleSubmit()}>
          {isSending ? 'Wysyłanie...' : 'Zapisz'}
        </button>
      </div>}
    </>
  )
}

export default Materials